import { COLORS } from '@btime/constants'
import { compose, prop } from 'ramda'
import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Title } from '../../../components/presentation/Text'
import { translateLog } from '../_locales/logKeyGenerator'
import { useCurrentModal } from '../../../components/modals/ModalsContext'
import Separator from '../../../components/helpers/Separator'
import TabsMenu from '../../../components/tabs/TabsMenu'

const ModalHeader = () => {
  const { t } = useTranslation(['logs', 'common'])
  const { data: log } = useCurrentModal()

  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm:ss'), prop('insertedAt'))(log)
  const happenedAt = compose(formatDate('DD/MM/YYYY HH:mm:ss'), prop('happenedAt'))(log)

  return (
    <>
      <Title size="h4" strong color={COLORS.dark2} noMargin>
        {translateLog(t, log)}
      </Title>
      <SmallText color={COLORS.dark3}>
        {t('common:createdAt')} {happenedAt} ({t('logs:saved')}: {createdAt})
      </SmallText>

      <Separator weight={6} />

      {log.requestId && <TabsMenu t={t} />}
    </>
  )
}

export default ModalHeader
